/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core"
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import PreExpire from './PreExpire';
import { AuthContext } from "../../AuthProvider";

const SubscriptionPlan = () => {
    const theme = useSelector(state => state.theme.theme);
    const { subscription } = useContext(AuthContext);

    return (
        //!subscription?.isFreeTrial ? null :
        <div className="subscription-plan-detail bg-white dark:darkmode-background dark:darkmode-blur-before relative rounded-25" css={{width: '700px'}}>
            <PreExpire isFreeTrial={subscription?.isFreeTrial} isSubscriptionExpired={subscription?.isSubscriptionExpired} isFreeTrialExpired={subscription?.isFreeTrialExpired} data={subscription} theme={theme} />
        </div>
    );
};

export default SubscriptionPlan;
